class RelatedProductsSlider extends HTMLElement {
	constructor() {
		super();
		this.swiperInstance = null;
		this.swiperEl = null;
		this.loadListenerAttached = false;
	}

	connectedCallback() {
		this.swiperEl = this.querySelector('.swiper-related-products');
		if (!this.swiperEl) return;
        this.initSwiper();
	}

	initSwiper() {
		if (typeof Swiper === 'undefined') {
			if (!this.loadListenerAttached) {
				window.addEventListener('load', this.handleWindowLoad, { once: true });
				this.loadListenerAttached = true;
			}
			return;
		}

		const sectionId = this.getAttribute('data-section-id');

		const config = {
			slidesPerView: 2,
			spaceBetween: 1,
			centeredSlides: true,
			loop: true,
            breakpoints: {
                990: {
                    slidesPerView: 4,
					centeredSlides: false,
					loop: false,
                }
            }
		};

		this.swiperInstance = new Swiper(this.swiperEl, config);
	}

    handleWindowLoad() {
		this.loadListenerAttached = false;
	}
}

if (!customElements.get('related-products-slider')) {
	customElements.define('related-products-slider', RelatedProductsSlider);
}